(function Module() {
	'use strict';

	var	_ = require('lodash');
	var log = require('parnell-log');

	module.exports = {
		apply: function apply(app) {
			function MessageFactory() {
				var self = this;
				var listeners = [];

				function remove(listener) {
					if (listener) {
						listeners = _.without(listeners, listener);
					}
				}

				function find(listenerId, eventKey) {
					return _.find(listeners, function findExisting(existing) {
						return existing.id === listenerId && existing.key === eventKey;
					});
				}

				// dispatch a message to any listeners that are registered
				self.dispatch = function dispatch(key, value) {
					var listenersToRemove = [];
					var dispatchCount = 0;
					var errorCount = 0;
					var staleCount = 0;

					_.forEach(listeners, function eachListener(listener) {
						//TODO: not actually sure this will do anything...
						if (_.isNull(listener.self) || _.isUndefined(listener.self)) {
							// listener isn't there anymore, add this to the list to clean up
							listenersToRemove.push(listener);
							staleCount++;

							return true; // continue
						}

						if (_.isEmpty(listener.key) || listener.key === key) {
							try {
								dispatchCount++;
								listener.callback(key, value);
							}

							catch (e) {
								// something bad happened, lets not call this listener again
								listenersToRemove.push(listener);
								errorCount++;
							}
						}
					});

					// cleanup any old or broken listeners
					_.forEach(listenersToRemove, remove);

					if (dispatchCount) {
						log.debug('dispatched [' + key + '] message to ' + dispatchCount + ' listeners.');
					} else {
						log.warn('dispatched [' + key + '] message, but noone was listening.');
						log.debug(listeners.length + ' total listeners registered');
					}

					if (errorCount) {
						log.debug(errorCount + ' listener callbacks resulted in errors');
					}

					if (staleCount) {
						log.debug('removed ' + staleCount + ' stale listener references');
					}
				};

				// use a unique Id for each listener so transient listeners can be replaced
				// eventKey is optional: may be a string or undefined
				self.addListener = function addListener(listenerId, listener, callback, eventKey) {
					remove(find(listenerId, eventKey));
					listeners.push({
						id: listenerId,
						self: listener,
						callback: callback,
						key: eventKey
					});
				};

				// remove a listener directly
				self.removeListener = function removeListener(listenerId, eventKey) {
					remove(find(listenerId, eventKey));
				};

				return self;
			}

			app.factory('MessageFactory', [MessageFactory]);
		}
	};
})();
